import { Camera } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components/ui/button';

import FaceScanBg from 'assets/images/face-scan/face-scan-bg.png';
import ScanLady from 'assets/images/face-scan/start-scan.png';

export default function StartScanButton({ onScan }: { onScan: () => void }) {
  const { t } = useTranslation();

  return (
    <div
      className='hidden sm:flex w-60 lg:w-full z-[100] h-16 lg:h-20 bg-[#1C244A] rounded-2xl sm:absolute sm:-top-16 lg:top-0 right-0 lg:relative justify-end items-center bg-cover bg-center'
      style={{
        backgroundImage: `url(${FaceScanBg})`,
      }}
      id='start-scan'
    >
      <div className='absolute bottom-0 left-0 h-24 lg:h-28'>
        <img src={ScanLady} alt='scan' className='object-cover w-20 h-full' />
      </div>

      <Button
        className='mr-6 text-sm rounded-full bg-rose-400 hover:bg-rose-400/90'
        size='sm'
        onClick={onScan}
      >
        <Camera className='w-4 h-4 mr-2' />
        {t('start_scan')}
      </Button>
    </div>
  );
}
